<template>
  <button
    ref="savebtn"
    class="btn btn-primary save-btn"
    :disabled="disabled || loading"
    type="submit"
    @click="onSave"
    :class="{ 'keep-width': saved || loading || saveErr, 'err-animation': saveErr, 'btn-primary-outline': outline }"
    :style="cssProps"
  >
    <span v-show="loading"><i class="fa-light fa-circle-notch fa-spin"></i> </span>
    <span v-show="saved"><i class="fa-light fa-check"></i> </span>
    <span v-show="saveErr"><i class="fa-light fa-exclamation-circle"></i> </span>
    <span v-show="!loading && !saved && !saveErr"> {{ buttonText }} </span>
  </button>
</template>

<script>
export default {
  data() {
    return {
      standardWidth: null,
    };
  },
  props: {
    disabled: Boolean,
    loading: Boolean,
    buttonText: String,
    onSave: Function,
    saved: Boolean,
    saveErr: Boolean,
    outline: Boolean
  },
  computed: {
    cssProps() {
      return {
        "--standard-width": `${this.standardWidth}px`,
      };
    },
  },

  mounted() {
    this.standardWidth = this.$refs.savebtn.clientWidth;
  },
  watch: {
    saved: {
      handler: function() {
        if (this.saved == true) {
          setTimeout(() => {
            this.$emit("saveCompleteHandled");
          }, 2000);
        }
      },
    },
    saveErr: {
      handler: function() {
        if (this.saveErr == true) {
          setTimeout(() => {
            this.$emit("saveErrHandled");
          }, 3000);
        }
      },
    },
  },
};
</script>

<style lang="less">
.save-btn {
    transition: .1s;
  &.keep-width {
    min-width: var(--standard-width);
  }
  &.err-animation{
    animation: shake-animation .4s ease ;
    transform-origin: 50% 50%;
  }
}

@keyframes shake-animation {
   0% { transform:translate(0,0) }
  10% { transform:translate(3px,0) }
  30% { transform:translate(0,0) }
  50% { transform:translate(3px,0) }
  70% { transform:translate(0,0) }
  80% { transform:translate(3px,0) }
  100% { transform:translate(0,0) }

}
</style>
